import { capitalize as _capitalize } from "lodash";
import { upperFirst as _upperFirst } from "lodash";

export const capitalize = (word: string) => {
	return _capitalize(word);
};

export const upperFirst = (string: string) => {
	return _upperFirst(string.toLowerCase());
};

export const isNullOrWhiteSpace = (string: string | null | undefined) => {
	return string === null || string === undefined || string.trim() === "";
};

export function keepDigits(s: string): string {
	return s.replace(/\D/g, "");
}

export const normalizePhoneNumber = (phoneNumber?: string) => phoneNumber?.replace(/\s+/g, "") ?? "";
